import React, { useState, useEffect } from "react";
import {
  Box,
  Flex,
  Text,
  Select,
  Td,
  Input,
  Stack,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Spinner,
  Button,
  Checkbox,
  Center,
  useBreakpointValue,
  Tfoot,
} from "@chakra-ui/react";
import axios from "axios";
import styles from "../Tabel.module.css";
import { ACCOUNTS_URL } from "../../../../Globalapi/Globalapi";
const TrialBalanceTable = () => {
  const [trialBalanceData, setTrialBalanceData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(12);
  const [fdate, setFdate] = useState(new Date().toISOString().split("T")[0]); // Set initial date to current date
  const [showData, setShowData] = useState(true); // State to control when to fetch data
  const [ctotal, setCtotal] = useState([]);
  const [dtotal, setDtotal] = useState([]);
  const cmpId = sessionStorage.getItem("cmp_id");
  const [companyData, setCompanyData] = useState(null);
  const [userId, setUserId] = useState(null);
  const [error, setError] = useState(null);
  useEffect(() => {
    if (fdate && showData) {
      // Only fetch data when `showData` is true
      const fetchTrialBalanceData = async () => {
        setLoading(true);
        try {
          const response = await axios.post(
            `${ACCOUNTS_URL}/reports/load_trail_balance.php`,
            { fdate, cmp_id: cmpId }
          );
          if (response.data.success === true) {
            setTrialBalanceData(response.data.voucherData);
            setCtotal(response.data.creditTotal || []);
            setDtotal(response.data.debitTotal || []);
          } else {
            console.error(
              "Failed to fetch trial balance data:",
              response.data.message
            );
          }
        } catch (error) {
          console.error("Error fetching trial balance data:", error);
        }
        setLoading(false);
      };
      fetchTrialBalanceData();
    }
  }, [fdate, showData, cmpId]);

  // Filter and pagination logic
  const indexOfLastRow = currentPage * rowsPerPage;
  const indexOfFirstRow = indexOfLastRow - rowsPerPage;

  // Ensure trialBalanceData is defined and is an array before slicing
  const currentData = Array.isArray(trialBalanceData)
    ? trialBalanceData.slice(indexOfFirstRow, indexOfLastRow)
    : [];
  const totalPages = Math.ceil(
    (Array.isArray(trialBalanceData) ? trialBalanceData.length : 0) /
      rowsPerPage
  );

  const handlePageChange = (page) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
    }
  };

  const renderRow = (item, index) => {
    const serialNumber = indexOfFirstRow + index + 1;
    return (
      <Tr key={item.account_code}>
        <Td py="12px" px="8px" textAlign="center">
          <Checkbox />
        </Td>
        <Td py="12px" px="20px">
          {item.L_name}
        </Td>
        <Td py="12px" px="20px" textAlign="right">
          {item.debit}
        </Td>
        <Td py="12px" px="20px" textAlign="right">
          {item.credit}{" "}
        </Td>
      </Tr>
    );
  };

  const handleSubmit = () => {
    setShowData(true); // Set to true when submit button is clicked
  };

  useEffect(() => {
    const storedUserId = sessionStorage.getItem("user_id");
    if (storedUserId) {
      setUserId(storedUserId);
    } else {
      setError("User not logged in or user_id not found in sessionStorage");
    }
  }, []);

  useEffect(() => {
    if (userId) {
      const fetchCompanyDetails = async () => {
        try {
          const response = await fetch(
            `${ACCOUNTS_URL}/settings/company_details.php`,
            {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify({ user_id: userId }),
            }
          );

          const data = await response.json();

          if (data.status === 200) {
            setCompanyData(data.data);
          } else {
            setError("No company found for this user.");
          }
        } catch (err) {
          setError("Error fetching company details.");
        }
      };

      fetchCompanyDetails();
    }
  }, [userId]); // Run when userId is set

  const printVoucher = (data) => {
    const isMobile = /Mobi|Android/i.test(navigator.userAgent);

    // Define the printable content as HTML
    const printableContent = `
            <html>
                <head>
                    <style>
                        body { font-family: 'Poppins', sans-serif; margin: 20px; }
                        .header, .footer { text-align: center; font-weight: bold; margin-bottom: 10px; }
                        .header h2 { margin: 0; font-size: 24px; }
                        .header p { margin: 0; font-size: 14px; }
                        table { width: 100%; border-collapse: collapse; margin-top: 15px; }
                        th, td { border: 1px solid #ddd; padding: 8px; }
                        th { background-color: #0073e6; color: white; }
                        tr:nth-child(even) { background-color: #f2f2f2; }
                        tr:hover { background-color: #ddd; }
    
                        /* Ensure styles are applied for print */
                        @media print {
                            th { background-color: #0073e6 !important; color: white !important; -webkit-print-color-adjust: exact; }
                            tr:nth-child(even) { background-color: #f2f2f2 !important; -webkit-print-color-adjust: exact; }
                            tr:hover { background-color: #ddd !important; -webkit-print-color-adjust: exact; }
                        }
                    </style>
                </head>
                <body>
                  <div class="header">
   ${
     companyData?.Company_Name?.startsWith("No") === false
       ? `<h2>${companyData.Company_Name}</h2>`
       : ""
   }

   
    ${
      companyData?.address?.startsWith("No") === false
        ? `<p>${companyData.address}</p>`
        : ""
    }
    ${
      companyData?.Tin?.startsWith("No") === false
        ? `<p>GSTIN/UIN: ${companyData.Tin}</p>`
        : ""
    }
    ${
      companyData?.Email_Id?.startsWith("No") === false
        ? `<p>Email: ${companyData.Email_Id}</p>`
        : ""
    }
</div>
                    <table>
                        <thead>
                            <tr>
                                <th style="text-align: center; padding: 12px;">Particulars</th>
                                <th style="text-align: right; padding: 12px;">Debit</th>
                                <th style="text-align: right; padding: 12px;">Credit</th>
                            </tr>
                        </thead>
                        <tbody>
                            ${trialBalanceData
                              .map(
                                (item) => `
                                <tr>
                                    <td style="padding: 12px 20px;">${item.L_name}</td>
                                    <td style="padding: 12px 20px; text-align: right;">${item.debit}</td>
                                    <td style="padding: 12px 20px; text-align: right;">${item.credit}</td>
                                </tr>
                            `
                              )
                              .join("")}
                        </tbody>
                    </table>
                </body>
            </html>
        `;

    if (isMobile) {
      // On mobile, open a new window with the printable content
      const printWindow = window.open("", "_blank");
      printWindow.document.open();
      printWindow.document.write(printableContent);
      printWindow.document.close();
      printWindow.print();
    } else {
      // On desktop, use an iframe for printing
      const iframe = document.createElement("iframe");
      document.body.appendChild(iframe);

      // Ensure the iframe is not visible
      iframe.style.position = "absolute";
      iframe.style.width = "0";
      iframe.style.height = "0";
      iframe.style.border = "none";

      // Access the iframe's document and write content
      const iframeDoc = iframe.contentWindow.document;
      iframeDoc.open();
      iframeDoc.write(printableContent);
      iframeDoc.close();

      // Print from the iframe and remove it afterward
      iframe.contentWindow.focus();
      iframe.contentWindow.print();
      document.body.removeChild(iframe);
    }
  };

  return (
    <Box mt={3} width="100%" minH="750px" p={1}>
      <Flex
        justify="space-between"
        align="center"
        className="sb"
        p={3}
        wrap={{ base: "wrap", md: "nowrap" }} // Allow wrapping on mobile
      >
        <Flex
          align="center"
          mb={{ base: 4, md: 0 }}
          justify={{ base: "flex-start", md: "center" }}
        >
          <Text mr={2}>Rows Per Page</Text>
          <Select
            width="100px"
            value={rowsPerPage}
            onChange={(e) => {
              setRowsPerPage(Number(e.target.value));
              setCurrentPage(1);
            }}
            borderColor="#E9EDF4"
          >
            <option value={12}>12</option>
            <option value={20}>20</option>
            <option value={50}>50</option>
          </Select>
          <Text ml={2}>Entries</Text>
        </Flex>

        <Stack
          direction={{ base: "column", md: "row" }} // Stack vertically on mobile
          spacing={4}
          width={{ base: "100%", md: "auto" }} // Full width on small screens
        >
          <Input
            type="date"
            placeholder="From Date"
            value={fdate}
            borderColor="#E9EDF4"
            onChange={(e) => setFdate(e.target.value)}
            width={{ base: "100%", md: "auto" }} // Full width on mobile, auto on larger screens
          />
        </Stack>

        {/* Submit button */}
        <Button
          onClick={handleSubmit}
          bg="teal"
          color="white"
          mt={{ base: 4, md: 0 }}
        >
          Submit
        </Button>
        <Button colorScheme="teal" onClick={printVoucher}>
          Print
        </Button>
      </Flex>

      {/* <Box
        style={{ overflowX: "auto" }}
        // w={{ base: "367px", md: "100%" }}
        className={styles.Table}
      >
        {loading ? (
          <Center>
            <Text>No Trial Balance Entries Found</Text>
          </Center>
        ) : (
          <Table
            sx={{
              "tbody tr:nth-of-type(even)": { backgroundColor: "#f2f4f8" },
            }}
            borderWidth="1px"
          >
            <Thead>
              <Tr>
                <Th
                  textAlign="center"
                  textTransform="none"
                  fontFamily="'Poppins', sans-serif"
                >
                  <Checkbox />
                </Th>

                <Th textTransform="none" fontFamily="'Poppins', sans-serif">
                  Particulars
                </Th>

                <Th
                  textTransform="none"
                  textAlign="right"
                  fontFamily="'Poppins', sans-serif"
                >
                  Debit
                </Th>
                <Th
                  textTransform="none"
                  textAlign="right"
                  fontFamily="'Poppins', sans-serif"
                >
                  Credit
                </Th>
              </Tr>
            </Thead>
            <Tbody>
              {currentData.length > 0 ? (
                currentData.map((item, index) => renderRow(item, index))
              ) : (
                <Tr>
                  <Td colSpan={7} textAlign="center">
                    No Trial Balance Entries Found
                  </Td>
                </Tr>
              )}
            </Tbody>
          </Table>
        )}
      </Box>
      <Table
        sx={{
          "tbody tr:nth-of-type(even)": { backgroundColor: "#f2f4f8" },
        }}
      >
        <Tbody>
          <Tr>
            <Td py="12px" px="20px" textAlign="right"></Td>

            <Td py="12px" px="90px" textAlign="left" fontWeight="bold">
              Current Total
            </Td>
            <Td py="12px" px="20px" textAlign="right"></Td>
            <Td py="12px" px="30px" textAlign="right"></Td>
            <Td py="12px" px="65px" textAlign="right" fontWeight="bold">
              {dtotal} Dr
            </Td>
            <Td py="12px" px="6px" textAlign="right" fontWeight="bold">
              {ctotal} Cr
            </Td>
          </Tr>
        </Tbody>
      </Table> */}
      <Box
        style={{ overflowX: "auto" }}
        className={styles.Table}
        w="100%" // Ensure it takes full available width
      >
        {loading ? (
          <Center py={10}>
            <Text>Loading data...</Text>
          </Center>
        ) : (
          // 2. Add minWidth to force horizontal scroll on small screens
          <Table
            minWidth={{ base: "500px", md: "100%" }} // Force scroll below 500px, but full width otherwise
            variant="simple"
            size="sm" // Use small size for compactness
            sx={{
              "tbody tr:nth-of-type(even)": { backgroundColor: "#f2f4f8" },
            }}
            borderWidth="1px"
          >
            <Thead>
              <Tr bg="gray.100">
                {/* Checkbox column - keep narrow */}
                <Th
                  textAlign="center"
                  textTransform="none"
                  fontFamily="'Poppins', sans-serif"
                  w="5%" // Fixed small width
                >
                  <Checkbox />
                </Th>
                {/* Particulars column - allow it to grow */}
                <Th
                  textTransform="none"
                  fontFamily="'Poppins', sans-serif"
                  w="65%"
                >
                  Particulars
                </Th>
                {/* Debit column - numeric alignment and fixed width */}
                <Th
                  textTransform="none"
                  textAlign="right"
                  fontFamily="'Poppins', sans-serif"
                  w="15%"
                >
                  Debit
                </Th>
                {/* Credit column - numeric alignment and fixed width */}
                <Th
                  textTransform="none"
                  textAlign="right"
                  fontFamily="'Poppins', sans-serif"
                  w="15%"
                >
                  Credit
                </Th>
              </Tr>
            </Thead>

            <Tbody>
              {currentData.length > 0 ? (
                currentData.map((item, index) => renderRow(item, index))
              ) : (
                <Tr>
                  {/* colSpan is 4 (Checkbox, Particulars, Debit, Credit) */}
                  <Td colSpan={4} textAlign="center" py={5}>
                    No Trial Balance Entries Found
                  </Td>
                </Tr>
              )}
            </Tbody>

            {/* 3. Integrate Total Row using Tfoot */}
            <Tfoot>
              <Tr bg="blue.100" fontWeight="bold">
                {/* Empty cell for Checkbox column */}
                <Td></Td>
                {/* Current Total Label - spans the particulars column */}
                <Td
                  textAlign={{ base: "left", md: "right" }}
                  px={{ base: 2, md: 5 }} // Adjusted padding for mobile
                  py={2}
                >
                  Current Total
                </Td>
                {/* Debit Total */}
                <Td isNumeric px={2}>
                  {dtotal} Dr
                </Td>
                {/* Credit Total */}
                <Td isNumeric px={2}>
                  {ctotal} Cr
                </Td>
              </Tr>
            </Tfoot>
          </Table>
        )}
      </Box>  
      {currentData.length > 0 && (
        <Flex justify="end" className="sb2" borderTopWidth="1px" mt={1} p={3}>
          <Button
            onClick={() => handlePageChange(currentPage - 1)}
            isDisabled={currentPage === 1}
          >
            Prev
          </Button>
          <Stack direction="row" mx={2}>
            {currentPage > 1 && (
              <>
                <Button onClick={() => handlePageChange(1)}>1</Button>
                {currentPage > 2 && <Text>...</Text>}
              </>
            )}
            <Button backgroundColor="teal" color="white">
              {currentPage}
            </Button>
            {currentPage < totalPages - 1 && (
              <>
                <Text>...</Text>
                <Button onClick={() => handlePageChange(totalPages)}>
                  {totalPages}
                </Button>
              </>
            )}
          </Stack>
          <Button
            onClick={() => handlePageChange(currentPage + 1)}
            isDisabled={currentPage === totalPages}
          >
            Next
          </Button>
        </Flex>
      )}
    </Box>
  );
};

export default TrialBalanceTable;
